export default __webpack_public_path__ + "static/media/phil_profile_pic.56ef698c.jpeg";